import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, TimePicker, DatePicker, DateTimePicker } from 'material-ui-pickers';
import './Pickers.scss';

const Pickers = ({
    value, datepicker, timepicker, onChange, disablePast, disableFuture, yearonly, yearmonth, label, minDate
}) => {
    const [defaultValue, selectedValue] = useState(value !== '' ? value : new Date());

    useEffect(() => {
        if (value !== '') {
            selectedValue( value !== '' ? value : new Date() );
        }
    },[value]);

    const handleDateChange = date => {
        selectedValue( date );
        onChange(date);
    };

    let format = 'DD MMMM YYYY';
    let views = ['year', 'month', 'day'];

    if (yearonly) {
        format = 'YYYY';
        views = ['year'];
    } else if (yearmonth) {
        format = 'MMMM YYYY';
        views = ['year', 'month'];
    }

    if (datepicker) {
        return (
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {label && <div className='label'>{label}</div>}
                <DatePicker
                    className='Pickers datetimepicker'
                    format={format}
                    value={new Date(defaultValue)}
                    minDate={new Date(minDate)}
                    onChange={handleDateChange}
                    disablePast={disablePast}
                    disableFuture={disableFuture}
                    views={views}
                />
            </MuiPickersUtilsProvider>
        );
    };

    if (timepicker) {
        return (
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {label && <div className='label'>{label}</div>}
                <TimePicker
                    className='Pickers datetimepicker'
                    value={defaultValue}
                    onChange={handleDateChange}
                    disablePast={disablePast}
                    disableFuture={disableFuture}
                />
            </MuiPickersUtilsProvider>
        );
    };

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            {label && <div className='label'>{label}</div>}
            <DateTimePicker
                className='Pickers datetimepicker'
                value={new Date(defaultValue)}
                minDate={new Date(minDate)}
                onChange={handleDateChange}
                disablePast={disablePast}
                disableFuture={disableFuture} 
            />
        </MuiPickersUtilsProvider>
    );
}

Pickers.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Object)
    ]),
    onChange: PropTypes.func,
    datepicker: PropTypes.bool,
    timepicker: PropTypes.bool,
    disablePast: PropTypes.bool,
    disableFuture: PropTypes.bool,
    yearonly: PropTypes.bool,
    yearmonth: PropTypes.bool,
    label: PropTypes.string
};

Pickers.defaultProps = {
    value: ['', new Date()],
    onChange: () => {},
    datepicker: false,
    timepicker: false,
    disablePast: false,
    disableFuture: false,
    yearonly: false,
    yearmonth: false,
    label: null
};

export default Pickers;


// WEBPACK FOOTER //
// ./common/Forms/Pickers/Pickers.js